module.exports = __webpack_public_path__ + "static/media/theme.387757a9.png";